/*
 * SignUpByPhone Slice
 *
 */

import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { ContainerState, ActionTriggerProps } from './types';

// The initial state of the SignUpByPhone Page container
export const initialState: ContainerState = {
  loading: false,
  done: false,
  error: null,
  data: null,
};

const signUpByPhoneSlice = createSlice({
  name: 'signUpByPhone',
  initialState,
  reducers: {
    fetchTrigger(state, action: PayloadAction<ActionTriggerProps>) {
      state.loading = true;
      state.done = false;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<ActionTriggerProps>) {
      state.done = true;
      state.data = action.payload;
    },
    fetchFailed(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    fetchFulfilled(state) {
      state.loading = false;
      state.done = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = signUpByPhoneSlice;
